define('vspot-angular/services/google-service',['vspot-user'], function (googleUser) {
    'use strict';
    var loginSource;

    if (window.location.href.indexOf('client') > 1) {
        //participant page
        loginSource =  'participant_path'
    } else {
        //organizer page
        loginSource = 'organizer_path'
    } 

    return ['resources.User', function (gUser) {
        require(['google'],
            function(gapi) {
                    gapi.load('auth2', function() {   
                        var auth2 = gapi.auth2.init({
                            // This gets replaced by the deployment script. DO NOT MOVE IT to another file unless
                            // you update the deploy script
                            //dev
                            'client_id': "169255260842-ojsa3235vuqlbljrugns4k6q5mkvf0dc.apps.googleusercontent.com"
                            // 'client_id': '408130889961-0uvgc4s8daspbmvigovmdljcin19pue4.apps.googleusercontent.com'
                        });
                    });
            }
        );

        return {
            googleLogin : function(callback) {
                var GoogleAuth, googleUser, profile, id_token;
                    GoogleAuth = gapi.auth2.getAuthInstance();
                var self = this;

                GoogleAuth.signIn().then(function(){
                        googleUser = GoogleAuth.currentUser.get(),
                        profile = googleUser.getBasicProfile(),
                        id_token = googleUser.getAuthResponse().id_token;
            
                    if (id_token && profile) {
                        self.verifyGoogleLogin(id_token, profile.getId(), loginSource).$promise.then(function(result) {
                            if(result.status) {
                                callback(result.email, result.mobile_redirect, result, true);
                            }
                        });
                    }
                });
            },

            verifyGoogleLogin : function(idToken, profileId, loginSource, callback) {
                return gUser.verifyGoogleLogin({token:idToken, uid:profileId,  source: loginSource});
            }
        };
    }];
});

